import React, {useCallback, useEffect, useState} from 'react'
import {API, graphqlOperation} from 'aws-amplify'
import {useNavigate, useSearchParams} from 'react-router-dom'

import {isFunction, persistPageState} from 'utils'
import {VmIcons, VmInput, VmText, VmView} from 'components'
import {ReportMobile} from 'template'
import {
  ProgressFullScreen,
  VmCardReport,
  VmMobileFilter,
  VmPulltoRefresh,
} from 'molecules'
import {Page500} from 'pages'
import QueryString from 'qs'
import axios from 'axios'
import {empty, tglYMD} from 'utils/functions'
import satusehaticon from '../../assets/satusehat.png'
import moment from 'moment'

const {
  REACT_APP_BASE_URL_DOKTER: APIDOC,
  REACT_APP_BASE_URL_UTAMA_PHP7: API7,
  REACT_APP_BASE_URL_SATUSEHAT: APISATUSEHAT,
} = process.env

export default function MobLapPas({
  classNameANCHORHeader = '',
  classNameANCHORContent = '',
  ...props
}) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const dctid = searchParams.get('dctid')
  const initialApiParams = Object.assign(
    {
      reg: 'db',
      uid: dctid,
      limit: 10,
      offset: 0,
      dateStart: new Date(moment().format('YYYY-MM-01')),
      dateEnd: new Date(),
      dateType: 2,
      bulan: moment().format('YYYY-MM-01'),
      tahun: '',
      a: 'dk13',
      date: '',
      cari: '',
      sort: '',
      pasaktif: 'ALL',
    },
    props?.dctid ? {dctid: props.dctid} : {}
  )
  const initialFilter = {
    filterFieldsValue: [
      {
        'Semua Periode': [
          {
            value: '',
            label: 'Berdasarkan Tahun',
            flag: 'tahun',
          },
          {
            value: '',
            label: 'Berdasarkan Bulan',
            flag: 'bulan',
          },
          {
            value: '',
            label: 'Berdasarkan Tanggal',
            flag: 'tanggal',
          },
        ],
      },
    ],
    currentOpenedFilter: 'Semua Periode',
    activeFilterHead: ['Semua Periode'],
    activeFilterHeadLabel: {
      'Semua Periode': `${moment(initialApiParams.dateStart).format(
        'MMM-YYYY'
      )}`,
    },
    dateFilterFlag: {bulan: true},
    sortIcon: '',
    activeFilter: {
      date: {
        bulan: new Date(initialApiParams.dateStart),
      },
      dateType: initialApiParams.dateType,
    },
    dateValue: {
      datePickerValue: new Date(initialApiParams.dateStart),
    },
  }

  // UI State
  const [error, setError] = useState('')
  const [data, setData] = useState('')
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState(initialFilter)
  const [cari, setCari] = useState('')
  const [count, setCount] = useState(0)

  // Api State
  const [hasMore, setHasMore] = useState(true)
  const [apiParams, setApiParams] = useState({...initialApiParams})

  useEffect(() => {
    fetchData(apiParams)
  }, [
    apiParams.cari,
    apiParams.bulan,
    apiParams.tahun,
    apiParams.dateStart,
    apiParams.dateEnd,
    apiParams.sort,
    apiParams.pasaktif,
  ])

  // Handler on Error Props
  useEffect(() => {
    if (error && !loading) {
      if (isFunction(props?.onError)) {
        // props.onError(error)
      }
    }
  }, [error, loading])

  const onCardItemClick = useCallback(data => {
    if (isFunction(props.onCardItemClick)) {
      props.onCardItemClick(data)
    }
    persistPageState({filter, apiParams})
    navigate(`/prd-lap-pasien/${data.pasid}`)
  })

  const fetchData = async params => {
    // const prevParams = initial ? {} : apiParams
    // const params = {...prevParams, ...additionalParams}
    setLoading(true)
    try {
      const res = await axios
        .post(
          `${APIDOC}/prd-lap-pasien/index`,
          QueryString.stringify({...params})
        )
        .then(({data: res}) => {
          // Berhasil Get Data
          return res
        })
        .catch(e => {
          console.log('Terjadi Kesalahan saat fetchData')
        })

      const resData = res
      if (resData && resData.status == 1) {
        const parsedData = resData.data
        const parsedCount = resData.count ?? 0
        // console.log({parsedData})
        setData(parsedData)
        setCount(parsedCount)
        if (parsedData.length < 10) setHasMore(false)
        else setHasMore(true)
      } else {
        handleError()
      }
      setLoading(false)
    } catch (e) {
      // let runtimeError = handleLambdaRuntimeExit(e)
      // if (runtimeError) {
      //   return refetchLambdaError(runtimeError, params)
      // }
      setLoading(false)
      return handleError(e)
    }
  }
  const handleError = (e = '') => {
    setError({e: e ?? '', message: 'Terjadi kesalahan saat mengambil data'})
  }

  const fetchMore = async () => {
    const params = {...apiParams, offset: data.length}
    try {
      const res = await axios
        .post(`${APIDOC}/prd-lap-pasien/index`, QueryString.stringify(params))
        .then(({data: res}) => {
          // Berhasil Get Data
          return res
        })
        .catch(e => {
          console.log('Terjadi Kesalahan saat fetchMoreData')
        })

      const resData = res
      if (resData && resData.status == 1) {
        const parsedData = resData.data

        setData([...data, ...parsedData])
        if (parsedData.length < 10) return setHasMore(false)
      } else {
        handleError()
      }
    } catch (e) {
      let runtimeError = handleLambdaRuntimeExit(e)
      if (!runtimeError) return handleError(e)
      refetchLambdaError(runtimeError, params)
    }
  }

  const onChangeFilter = val => {
    const cleanObject = {dateStart: '', dateEnd: '', date: ''}
    let initialDate = {
      dateStart: tglYMD(val?.date?.start) ?? tglYMD(new Date()),
      dateEnd: tglYMD(val?.date?.end) ?? tglYMD(new Date()),
    }

    if (val?.clear) initialDate = {dateStart: '', dateEnd: ''}
    let params = {...val, ...initialDate, date: '', bulan: '', tahun: ''}

    if (val?.date?.bulan)
      params = {
        ...val,
        bulan: tglYMD(val?.date?.bulan),
        tahun: '',
        ...cleanObject,
      }
    if (val?.date?.tahun)
      params = {
        ...val,
        tahun: tglYMD(val?.date?.tahun),
        bulan: '',
        ...cleanObject,
      }
    if (val?.pasaktif === '')
      params = {
        ...val,
        pasaktif: 'ALL',
        ...cleanObject,
      }
    if (val?.pasaktif > 0)
      params = {
        ...val,
        ...cleanObject,
      }

    // console.log('onchangefilter params', params)
    setApiParams(prev => ({...prev, ...params}))
  }

  const onClearFilter = () => {
    const params = {
      ...initialApiParams,
      dateStart: '',
      dateEnd: '',
      dateType: '',
    }
    setApiParams(params)
    setCari('')
  }

  const onSubmitSearch = e => {
    if (e.key === 'Enter') {
      setApiParams({...apiParams, cari: e.target.value})
    }
  }

  const onRefresh = () => {
    setFilter(initialFilter)
    setCari('')
    setApiParams(initialApiParams)
  }

  const handleLambdaRuntimeExit = error => {
    if (error?.errors?.length > 0)
      return (
        error?.errors[0]?.message.includes(
          'Error: Runtime exited with error: exit status 129'
        ) && error?.errors[0]?.errorType === 'Lambda:Unhandled'
      )
    return false
  }

  const refetchLambdaError = async (runtimeError, params) => {
    let limitCall = 0
    while (runtimeError) {
      if (limitCall === 10) {
        runtimeError = false
        return
      }
      limitCall++
      await fetchData(params)
    }
  }

  if (loading)
    return (
      <ProgressFullScreen useBgColor visible={loading} className="!z-[100]" />
    )

  if (error && !loading) return <Page500 />

  if (data) {
    const searchInputStyle =
      'sticky w-full border-gray-400 text-gray-500 placeholder:text-gray-400 placeholder:text-sm h-10 rounded-xl p-2 mb-1 z-50'

    let headerFields = [{name: 'pastglreg', dateFormat: true}]
    let dataFields = [
      {
        dbColumn: 'pasaktif',
        children: (item, dbColumn) => {
          const alias = [
            {
              label: (
                <VmView className="px-2 rounded-md w-fit text-green-500 bg-green-200">
                  Aktif
                </VmView>
              ),
            },
            {
              label: (
                <VmView className="px-2 rounded-md w-fit text-red-500 bg-red-200">
                  Non Aktif
                </VmView>
              ),
            },
          ]
          return alias[item[dbColumn] - 1]?.label || <></>
        },
      },
      'pasrm',
      'pasnama',
      'pasalamat',
      'pastelp',
    ]
    let aliasFields = [
      {
        dbColumn: 'pasaktif',
        alias: [
          {
            value: 1,
            label: 'Belum Diperiksa',
            color: 'text-yellow-500 bg-yellow-200',
          },
          {
            value: 2,
            label: 'Dibatalkan',
            color: 'text-red-500 bg-red-200',
          },
          {
            value: 3,
            label: 'Sudah Diperiksa',
            color: 'text-blue-500 bg-blue-200',
          },
          {
            value: 4,
            label: (
              <VmView className="flex flex-row items-center">
                Sudah Disimpan
                <VmIcons
                  size={12}
                  name="VmLockClosedIcon"
                  variant="outline"
                  className="ml-1 stroke-green-600"
                />
              </VmView>
            ),
            color: 'text-green-500 bg-green-200',
          },
        ],
      },
    ]
    let imageComponent = {
      component: props => <VmIcons {...props} />,
      props: {
        size: 65,
        className: 'mr-2 rounded-full',
        variant: 'avatar',
      },
      dynamicProps: {
        forProps: 'name',
        dbColumn: 'pasjk',
        alias: [
          {'Laki-laki': 'VmLDewasaColorIcon'},
          {Lakilaki: 'VmLDewasaColorIcon'},
          {Perempuan: 'VmPDewasaColorIcon'},
          {'': 'VmPPDefaultIcon'},
        ],
      },
    }
    let statusDbColumn = 'pasaktif'
    let withStatus = false
    return (
      <VmPulltoRefresh onRefresh={onRefresh}>
        <ReportMobile
          withStatus={withStatus}
          data={data}
          statusDbColumn={statusDbColumn}
          headerFields={headerFields}
          dataFields={dataFields}
          customRender={(item, i) => {
            let terhubung_satusehat = !empty(item.pasid_satusehat)
            return (
              <VmCardReport
                button={true}
                buttonLabel="Detail"
                buttonAction={onCardItemClick}
                footerDividerVisible={false}
                headerFields={headerFields}
                item={item}
                key={i}
                index={i}
                fields={dataFields}
                onCardItemClick={onCardItemClick}
                imageComponent={imageComponent}
                aliasFields={aliasFields}
                withStatus={withStatus}
                statusDbColumn={statusDbColumn}
                customStatusComponent={
                  terhubung_satusehat ? (
                    <VmView className="flex items-center">
                      <VmText className="text-xs">Terhubung</VmText>
                      <img
                        width={36}
                        src={satusehaticon}
                        alt="satusehat-icon"
                      />
                    </VmView>
                  ) : (
                    <></>
                  )
                }
                // button={showButtonEdit || detailAttr.button}
                // buttonLabel={showButtonEdit ? 'Ubah' : detailAttr.buttonLabel}
                // buttonAction={() => {}}
                // buttonAdditionalProps={{variant: 'outline', color: 'primary'}}
              />
            )
          }}
          aliasFields={aliasFields}
          imageComponent={imageComponent}
          filterComponent={
            <VmMobileFilter
              className="pt-1.5"
              filterValue={filter}
              filterHandler={setFilter}
              filterFields={[
                {
                  'Semua Status': [
                    {value: 1, label: 'Aktif'},
                    {value: 2, label: 'Non Aktif'},
                  ],
                  dbColumn: 'pasaktif',
                },
                {
                  Sorting: [
                    {label: 'Tanggal Registrasi', dbColumn: 'pastglreg'},
                  ],
                },
              ]}
              onChange={onChangeFilter}
              onClear={onClearFilter}
            />
          }
          searchComponent={
            <VmInput
              value={cari}
              onChange={e => setCari(e.target.value)}
              type="text"
              className={searchInputStyle}
              placeholder="Cari No. WA / No. RM / Nama / Alamat Pasien"
              enterKeyHint="search"
              onKeyDown={onSubmitSearch}
            />
          }
          hasMore={hasMore}
          loadMore={fetchMore}
          onCardItemClick={onCardItemClick}
          empty={count <= 0 && !loading && !error}
          count={count ?? 0}
          headerAttr={{enable: false}}
          exportApiUrl={
            process.env.REACT_APP_BASE_URL_DOKTER + '/prd-lap-pasien/export'
          }
          exportApiParams={{
            ...initialApiParams,
            ...apiParams,
            ...cari,
            uid: dctid,
          }}
          exportPdfApiUrl={`/prd-lap-pasien/export?dctid=${dctid}&${QueryString.stringify(
            {...apiParams, limit: 99999}
          )}`}
          classNameANCHORHeader={classNameANCHORHeader}
          classNameANCHORContent={classNameANCHORContent}
          detailAttr={{
            button: true,
            buttonLabel: 'Detail',
            buttonAction: onCardItemClick,
            footerDividerVisible: false,
          }}
        />
      </VmPulltoRefresh>
    )
  }
}
